import {useEffect} from 'react';
import {Card, Row, Col} from 'antd';

import {useParams} from 'react-router-dom';
import {useBreadcrumbContext} from '../../../../domain/utility/AppContextProvider/BreadcrumbContextProvider';
import IntlMessages from '../../../../domain/utility/IntlMessages';
import MainUtils from '../../../../shared/utils/main';
import CreateCountryTabs from './country-tabs';

function CountryInfo() {
  const {setBreadcrumb}: any = useBreadcrumbContext();
  const {id} = useParams();

  useEffect(() => {
    setBreadcrumb([
      {
        text: <IntlMessages id='configuration.sideBarName' />,
        url: '/configuration/general-configuration',
      },
      {
        text: <IntlMessages id='configuration.countries' />,
        url: '/configuration/countries',
      },
      MainUtils.isEmptyValue(id)
        ? {
            text: <IntlMessages id='countries.add' />,
            url: '/configuration/countries/create',
          }
        : {
            text: <IntlMessages id='countries.edit' />,
            url: `/configuration/countries/edit/${id}`,
          },
    ]);
  }, [id]);

  return (
    <Card>
      <Row gutter={[30, 30]}>
        <Col span={24}>
          <CreateCountryTabs />
        </Col>
      </Row>
    </Card>
  );
}

export default CountryInfo;
